import { Heading } from "@instructure/ui";
import { t } from "i18next";
import { CourseCodeError } from "../components/CourseCodeError";

const Status = () => {
  return (
    <div>
      <Heading border="bottom">{t("status.title")}</Heading>
      <CourseCodeError />
    </div>
  );
};

export default Status;
